<template>
  <div class="container">
    <div class="title">
      <h1 id="test">Rédaction d'un article</h1>
    </div>
    <div class="body-editor">
      <div class="title">     
        <span data-tooltip="Nom de votre article" data-flow="top" class="title-tool-tip">
          <input type="text" placeholder="Titre de l'article" v-model="title" id="titre" maxlength="40">
        </span>
      </div>

      <vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor>
    </div>
    <div class="footer">
      <div class="visible">
      </div>
      <div class="buttons">
        <div class="container-buttons">
          <label class="label" title="Visible dès la publicaiton">
            <span :data-tooltip="textForVisibility" data-flow="top">
              <div class="toggle">
                <input class="toggle-state" type="checkbox" name="check" value="check" @change="changeVisibility" />
                <div class="toggle-inner">
                  <div class="indicator"></div>
                </div>
                <div class="active-bg"></div>
              </div>
            </span>
          </label>
          <div class="select-container">
            <select class="form-select" v-model="selectedCateg">
              <option v-for="categ of categList" :value="categ.Id" :key="categ.Id">{{categ.Label}}</option>
            </select>
            <router-link to="/cms-categ"><small>Ajouter une catégorie</small></router-link>
          </div>
          <button class="cancel" @click="$router.push('cms-gestion')">Annuler</button>
          <button class="publish" @click="createArticle">Publier</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { createArticle, getCategories } from "@/utils/cms" //methodes de création et de récupération des catégories de l'utilisateur
  export default {
    name: "CmsCreate",
    components: {
    },
    data() {
      return {
        content: "",
        isVisible: false, //Visibilité de l'article
        textForVisibility: 'Votre article ne sera pas visible', //Text du toolTip de la visibilité
        selectedCateg: -1,//Catégorie sélectionnée par défaut
        title: '', //titre de l'article
        categList: [], //Liste des catégories
        customToolbar: [ // Toolbar de l'éditeur
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike"], // toggled buttons
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          ["link"],
          //["link", "image", "video"],
          ["clean"] // remove formatting button
        ]
      }
    },
    mounted() {
      getCategories(this.$store.state.self.guid).then((response) => { //récupère les catégories de l'utilisateur
        this.categList = response; //Met en place la liste 
        if (this.categList && this.categList[0])
          this.selectedCateg = this.categList[0].Id //séléction par défaut de la catégorie 0
      })
    },
    methods: {
      changeVisibility: function () { //Met à jour la visibilité de l'article
        this.isVisible = !this.isVisible
        if (this.isVisible) this.textForVisibility = 'Votre article sera visible'
        else this.textForVisibility = 'Votre article ne sera pas visible'
      },
      createArticle: function () { //Fonction que créer un article

        if (this.title.trim() === '') { //Vérification des champs
          document.getElementById('titre').style.borderColor = '#FF5252';
          return;
        } else document.getElementById('titre').style.borderColor = 'lightgrey';

        if (this.content === '' || this.content === '<br>') //Vérification des champs
          return

        createArticle( //Création de l'article
          this.title,
          this.content,
          this.isVisible,
          this.selectedCateg
        ).then(() => {
          this.$router.push('/cms-gestion');
        })
      },
    }
  }
</script>

<style scoped>
  .label{
    
  }

  [data-tooltip] {
    position: relative;
    cursor: pointer;
    
  }
    [data-tooltip]:hover {
      animation: 1s tooltip;
    }

    [data-tooltip]:before,
    [data-tooltip]:after {
      line-height: 1;
      font-size: .9em;
      pointer-events: none;
      position: absolute;
      box-sizing: border-box;
      display: none;
      opacity: 0;
    }

    [data-tooltip]:before {
      content: "";
      border: 5px solid transparent;
      z-index: 100;
    }

    [data-tooltip]:after {
      content: attr(data-tooltip);
      text-align: center;
      min-width: 3em;
      max-width: 21em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 11px 12px;
      border-radius: 7px;
      background: #80A70E;
      color: #FFFFFF;
      z-index: 99;
    }

    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
      display: block;
      opacity: 1;
    }

    [data-tooltip]:not([data-flow])::before,
    [data-tooltip][data-flow="top"]::before{
      bottom: 100%;
      border-bottom-width: 0;
      border-top-color: #80A70E;
    }

    [data-tooltip]:not([data-flow])::after,
    [data-tooltip][data-flow="top"]::after {
      bottom: calc(100% + 5px);
    }

    [data-tooltip]:not([data-flow])::before, [tooltip]:not([data-flow])::after,
    [data-tooltip][data-flow="top"]::before,
    [data-tooltip][data-flow="top"]::after {
      left: 50%;
      -webkit-transform: translate(-50%, -4px);
      transform: translate(-50%, -4px);
    }

    [data-tooltip][data-flow="bottom"]::before {
      top: 100%;
      border-top-width: 0;
      border-bottom-color: #80A70E;
    }

    [data-tooltip][data-flow="bottom"]::after {
      top: calc(100% + 5px);
    }

    [data-tooltip][data-flow="bottom"]::before, [data-tooltip][data-flow="bottom"]::after {
      left: 50%;
      -webkit-transform: translate(-50%, 8px);
      transform: translate(-50%, 8px);
    }

    [data-tooltip][data-flow="left"]::before {
      top: 50%;
      border-right-width: 0;
      border-left-color: #80A70E;
      left: calc(0em - 5px);
      -webkit-transform: translate(-8px, -50%);
      transform: translate(-8px, -50%);
    }

    [data-tooltip][data-flow="left"]::after {
      top: 50%;
      right: calc(100% + 5px);
      -webkit-transform: translate(-8px, -50%);
      transform: translate(-8px, -50%);
    }

    [data-tooltip][data-flow="right"]::before {
      top: 50%;
      border-left-width: 0;
      border-right-color: #80A70E;
      right: calc(0em - 5px);
      -webkit-transform: translate(8px, -50%);
      transform: translate(8px, -50%);
    }

    [data-tooltip][data-flow="right"]::after {
      top: 50%;
      left: calc(100% + 5px);
      -webkit-transform: translate(8px, -50%);
      transform: translate(8px, -50%);
    }

  [data-tooltip=""]::after, [data-tooltip=""]::before {
    display: none !important;
  }



  #app-content {
    display: flex;
  }
  .container{
    min-width: 100%;
    min-height: 100%;
  }
  .container .title{
    min-width: 100%;
  }
  #editor {
    min-height: calc(100vh - 53px - 16px - 175px - 160px - 60px);
  }
  .footer{
    width: 100%;
    display:flex;
    margin-top: 1%;
  }
  .visible{
    width: 50%;
  }
  .buttons{
    width: 50%;
    display:flex;

  }
  .container-buttons {
      width:100%;
      height: 100%;
      display: flex;
      justify-content:right;
      align-items:center;
  }
  .buttons .container-buttons button {
    float: right;
    margin-right: 1%;
    color: white;
    font-family: 'DIN Pro';
    border: none;
  }
    .buttons .container-buttons label{
        margin-right:3%;
    }

    .select-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 3%;
    }
  .buttons .container-buttons .form-select {
    width: 100%;
  }
  .cancel {
    background: #FF5252;
  }
  .publish {
    background: #198754;
  }
  .cancel:hover {
    background: #d14646;
  }
  .publish:hover {
    background: #146741;
  }
  body {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-family: 'IBM Plex Mono', monospace;
    font-weight: 300;
  }

  .label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .label-text {
    margin-left: 8px;
    color:black;
  }

  .toggle {
    isolation: isolate;
    position: relative;
    height: 24px;
    width: 48px;
    border-radius: 15px;
    background: #9c9b9b; /*d6d6d6*/
    overflow: hidden;
  }

  .toggle-inner {
    z-index: 2;
    position: absolute;
    top: 1px;
    left: 1px;
    height: 22px;
    width: 46px;
    border-radius: 15px;
    overflow: hidden;


  }

  .active-bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 200%;
    background: #80a70e;
    transform: translate3d(-100%, 0, 0);
    transition: transform 0.05s linear 0.17s;
  }

  .toggle-state {
    display: none;
  }

  .indicator {
    height: 100%;
    width: 200%;
    background: white;
    border-radius: 13px;
    transform: translate3d(-75%, 0, 0);
    transition: transform 0.35s cubic-bezier(0.85, 0.05, 0.18, 1.35);
  }

  .toggle-state:checked ~ .active-bg {
    transform: translate3d(-50%, 0, 0);
  }

  .toggle-state:checked ~ .toggle-inner .indicator {
    transform: translate3d(25%, 0, 0);
  }
  .body-editor .title input {
    margin-left: 0%;
    height: 40px;
    font-size: 1.5rem;
    width: 50%;
  }
  #editor{
      margin-top: 1%;
  }
  .body-editor .title [data-tooltip]:after {
    font-size: 1.5rem;
  }
  .body-editor .title [data-tooltip]:not([data-flow])::after,
  .body-editor .title [data-tooltip][data-flow="top"]::after {
    bottom: calc(100% + 20px);
  }
  .body-editor .title [data-tooltip]:not([data-flow])::before,
  .body-editor .title [data-tooltip][data-flow="top"]::before {
    bottom: calc(100% + 15px);
  }
  #titre{
      border: 1px solid lightgrey;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Adherent/CmsCreate.vue